import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import { getSalesAttribute, getTrendsChartData } from 'gqlQueries/growthAnalysisQueries';
import { salesAttributeDataParser } from 'parser/salesAttributionDataParser';
import { salesTrendChartParser } from 'parser/salesTrendChartParser';

const errorMessage: string = 'Something went wrong!';

function useFetchSalesTrendChart() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);

    const { appConfig } = useContext(UserContext);

    const [
        fetchTrendsChartData,
        { data: salesTrendChartData, loading: salesTrendChartDataLoading, error: salesTrendChartDataError },
    ] = useLazyQuery(getTrendsChartData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getAttributeTrendChartData } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (getAttributeTrendChartData && 'data' in getAttributeTrendChartData) {
                const parsedData = salesTrendChartParser(getAttributeTrendChartData?.data, appConfig);
                setData(parsedData);
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        setLoading,
        fetchTrendsChartData: (variables: any) => {
            setData(null);
            setLoading(true);
            setError(null);
            //onFetchComplete(dummyData);
            fetchTrendsChartData(variables);
        },
    };
}

export { useFetchSalesTrendChart };
